import React, { useState } from "react";
// import { blog, post, stories } from "../../assets/image";
import { ReportList } from "../../../components/ReportComponents/ReportList";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/common/Loader";
import { GET_REPORT } from "../../../api/url";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { blog, post, stories } from "../../../assets/image";
export const Report = () => {


  const [activeTab, setActiveTab] = useState("blog");

  const tabs = [
    { key: "blog", label: "Blogs", image: blog },
    { key: "story", label: "Stories", image: stories },
    { key: "post", label: "post", image: post },
  ];

  const { data, isLoading, isRefetching } = useAppQuery({
    queryKey: [QUERY_KEYS.REPORTS, activeTab],
    url: `${GET_REPORT}?type=${activeTab}`,
  });

  if (!!isLoading || isRefetching) {
    return <Loader/>;
  }
  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-primary">Reports</h1>
          <p className="mt-2 text-sm text-gray-700 capitalize">Show All List Of Repors</p>
        </div>
      </div>
      <div className="w-full">
        <div className="flex justify-between border-b mb-3">
          <div className="flex gap-4">
            {tabs?.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-4 px-14 py-3 rounded-t-md transition-all duration-200 ${
                  activeTab === tab.key
                    ? "bg-white border border-b-0 border-gray-300 shadow-sm font-semibold"
                    : "text-grey hover:text-dark"
                }`}
              >
                <img className="w-7 h-7" src={tab.image} alt="" />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <ReportList data={data?.results?.data} activeTab={activeTab} />
      </div>
    </div>
  );
};
